// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"567c8077","201":"2a229bf7","619":"26bff2d1","666":"83ea34ac","787":"8bf214e9","976":"b2934f2f"}[chunkId] + ".chunk.js";
};